export const HIDE_SHAREITT_SITE_HEADER_JS = `
  const [headerElement] = document.getElementsByTagName('header');
  headerElement.style.display = 'none';
`;
